import * as QueryString from "query-string";
import RevolverPrecannedResults from "slotworks/integration/revolver/precanned/revolver-precanned-results";
import { RevolverRGSSchema } from "slotworks/integration/revolver/schema/revolver-rgs-schema";
import AutoplayModel from "slotworks/model/autoplay-model";
import SettingsModel from "slotworks/model/settings/settings-model";
import { Jurisdiction } from "slotworks/model/settings/settings-model";
import SlotDefinition from "slotworks/model/slot-definition";
import SymbolModel from "slotworks/server/symbols/symbol-model";
import DeviceInfo from "slotworks/utils/device-info";
import Point from "slotworks/utils/geom/point";
import WrapperMediator from "../wrapper/wrapper-mediator";

declare const __DEBUG__: boolean;

class RevolverModel {

    public creditBaseMultiplier: number;
    public game: string;
    public bet: string;
    public session: string;
    public jwt_token: string;
    public betConfig: any;
    public sendBetConfigInResult: boolean;
    private revolverRGSData: RevolverRGSSchema;

    private validParams: string[] = ["lang", "token", "game", "operator", "gameId", "operatorId", "site", "variant", "branding",
        "exit_url", "freeplay", "regulation", "rgs_url", "rgs_history_url", "currency", "gameCode", "fullscreen", 
        "rcelapsed", "rcinterval", "loader", "disableautoquickrc", "social", "rtpdisplay", "historymenu", "hidehistory", "hidertp"];

    private freespinIdentifiers: string[] = ["FREESPIN"];
    private spinIdentifiers: string[] = ["$BASE"];

    private languageCodeMap = new Map<string, string>()
        .set("cn", "zh-Hans")
        .set("zh", "zh-Hans")
        .set("zh-cn", "zh-Hans")
        .set("zh-hk", "zh-Hans")
        .set("zh-mo", "zh-Hans")
        .set("zh-sg", "zh-Hans")
        .set("zh-tw", "zh-Hans")
        .set("zh-hans", "zh-Hans");

    public addFreespinIdentifiers(identifiers: string[]) {
        this.freespinIdentifiers = this.freespinIdentifiers.concat(identifiers);
    }

    public addSpinIdentifiers(identifiers: string[]) {
        this.spinIdentifiers = this.spinIdentifiers.concat(identifiers);
    }

    public init(defaults: RevolverRGSSchema) {
        this.revolverRGSData = {} as RevolverRGSSchema;

/////////////////////////
        if (__DEBUG__) {
            this.revolverRGSData = defaults;
        }
//////////////////

        // Overwrite local config with url params
        const urlParams = QueryString.parse(location.search);

        // Check mandatory fields
//////////////////////////
/////////////////////////
/////////////////////////////////////////////
/////////////////////////////////////////////
///////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////
/////////////////////////////////////////
///////////////////////////////////////////////////
/////////////
/////////
//////////////////

        for (const param in urlParams) {
            if (urlParams && urlParams[param]) {
                if (this.validParams.indexOf(param) > -1) {
                    (this.revolverRGSData as any)[param] = urlParams[param];
                }
            }
        }

        if(urlParams["RegulationType"] == 2 && urlParams["grt"] && 
                typeof(urlParams["grt"]) == "string" &&  urlParams["grt"].toLowerCase() == "true") {
            SettingsModel.hideUkJurisdictionBar = true;
        }

        if(urlParams["disablemeterbar"] && typeof(urlParams["disablemeterbar"]) == "string" &&  urlParams["disablemeterbar"].toLowerCase() == "true") {
            SettingsModel.hideUkJurisdictionBar = true;
        }

        if (this.revolverRGSData.regulation) {

            const regulation = (Array.isArray(this.revolverRGSData.regulation) && this.revolverRGSData.regulation.length > 0) ? 
                this.revolverRGSData.regulation[0] : this.revolverRGSData.regulation;
            
            if(regulation && typeof(regulation) == "string") {
                const lowCaseRegulation = regulation.toLowerCase();

                switch(lowCaseRegulation) {
                    case "uk": 
                        SettingsModel.setJurisdiction(Jurisdiction.UK);
                        SettingsModel.language = "en";
                        break;
                    case "se": 
                        SettingsModel.setJurisdiction(Jurisdiction.SE);
                        break;
                    case "nl":
                        SettingsModel.setJurisdiction(Jurisdiction.NL);
                        SettingsModel.language = "nl";
                        break;
                    case "de":
                        SettingsModel.setJurisdiction(Jurisdiction.DE);
                        SettingsModel.language = "de";
                        break;
                    default:
                        SettingsModel.setJurisdiction(Jurisdiction.NONE);
                        break;
                }
            }
        }

        // Default to english if language isn't set
        if(!SettingsModel.jurisdictionSetLanguage || !SettingsModel.isJurisdiction([Jurisdiction.DE, Jurisdiction.UK, Jurisdiction.NL])) {
            SettingsModel.language = this.languageCodeMap.get(this.revolverRGSData.lang) ||
                this.revolverRGSData.lang || "en";
        }

        // social casino configuration
        if(urlParams["social"] && typeof(urlParams["social"]) == "string" &&  urlParams["social"].toLowerCase() == "true") {
            SettingsModel.socialSweepstakes = true;
        }
        if(SettingsModel.socialSweepstakes) {
            SettingsModel.language = "en-social";
        }

        if(urlParams["hidertp"] && typeof(urlParams["hidertp"]) == "string" &&  urlParams["hidertp"].toLowerCase() == "true") {
            SettingsModel.rtpdisplay = false;
        }
        if(urlParams["hidehistory"] && typeof(urlParams["hidehistory"]) == "string" &&  urlParams["hidehistory"].toLowerCase() == "true") {
            SettingsModel.historymenu = false;
        }

        // Forces
        this.revolverRGSData.forceStrings = defaults.forceStrings;
        for (const customStops in this.revolverRGSData.customStops) {
            if (this.revolverRGSData.customStops.hasOwnProperty(customStops)) {
                RevolverPrecannedResults.customStops.set(customStops, this.revolverRGSData.customStops[customStops]);
            }
        }

        SymbolModel.init(defaults.symbolData);

        // Update settings model
        SettingsModel.homeURL = this.revolverRGSData.exit_url;
        SettingsModel.historyURL = this.revolverRGSData.rgs_history_url;

        // Jurisdiction based hard coded values
        if (SettingsModel.isJurisdiction(Jurisdiction.SE)) {
            AutoplayModel.maxAutoplays = 100;
            SettingsModel.setQuickSpinDisabled(true);
            SettingsModel.minSpinTime = 3000;
            SettingsModel.midSpinTime = 900;
            SettingsModel.minSkipTime = 3000;
        } else if(SettingsModel.isJurisdiction(Jurisdiction.UK)) {
            AutoplayModel.autoplayDisabled = true;
            document.documentElement.classList.toggle("no_autoplay", true);
            SettingsModel.minSpinTime = 2500;
            SettingsModel.setSkipDisabled(true);
            SettingsModel.setQuickSpinDisabled(true);
        } else if(SettingsModel.isJurisdiction(Jurisdiction.NL)) {
            AutoplayModel.autoplayDisabled = true;
            document.documentElement.classList.toggle("no_autoplay", true);
        } else if(SettingsModel.isJurisdiction(Jurisdiction.DE)) {
            AutoplayModel.autoplayDisabled = true;
            document.documentElement.classList.toggle("no_autoplay", true);
            SettingsModel.minSpinTime = 5000;
            SettingsModel.midSpinTime = 2600;
            SettingsModel.setSkipDisabled(true);
            SettingsModel.setQuickSpinDisabled(true);
        } else {
            AutoplayModel.maxAutoplays = 1000;
        }

        if(this.revolverRGSData.disableautoquickrc && 
                typeof(this.revolverRGSData.disableautoquickrc) == "string" && 
                this.revolverRGSData.disableautoquickrc.toLowerCase() === "true") {
                    
            AutoplayModel.autoplayDisabled = true;
            document.documentElement.classList.toggle("no_autoplay", true);

            SettingsModel.setQuickSpinDisabled(true);
            SettingsModel.setSkipDisabled(true);

            SettingsModel.rcdisabled = true;
            document.documentElement.classList.toggle("no_rc", true);
        }

        if(SettingsModel.isJurisdiction(Jurisdiction.UK)) {
            if(urlParams["disableukbarplusrc"] && 
                    typeof(urlParams["disableukbarplusrc"]) == "string" && 
                    urlParams["disableukbarplusrc"].toLowerCase() == "true") {
                
                SettingsModel.hideUkJurisdictionBar = true;
                
                SettingsModel.rcdisabled = true;
                document.documentElement.classList.toggle("no_rc", true);
            }
        }

        WrapperMediator.start().then(() => {
            WrapperMediator.init();
        });
    }

    public getSessionLimitElapsed() {
        return Number(this.revolverRGSData.rcelapsed); 
    }

    public getSessionLimit() {
        return Number(this.revolverRGSData.rcinterval);     
    }

    public isFullscreenDisabled() {
        return this.revolverRGSData.fullscreen === "false"; 
    }

    public getBaseURL() {
        return this.revolverRGSData.rgs_url;
    }

    public getGame() {
        return this.revolverRGSData.game;
    }

    public getGameCode() {
        return this.revolverRGSData.game;
    }

    public isFreeplay() {
        return this.revolverRGSData.freeplay === "true";
    }

    public getOperator() {
        return this.revolverRGSData.operator;
    }

    public getToken() {
        return this.revolverRGSData.token;
    }

    public getSite() {
        return this.revolverRGSData.site;
    }

    public getBranding() {
        return this.revolverRGSData ? this.revolverRGSData.branding : "";
    }

    public getRegulation() {
        try {
            return (this.revolverRGSData && this.revolverRGSData.regulation) ? this.revolverRGSData["branding"] : null;
        } catch (e) {
            return null;
        }

    }

    public getVariant() {
        if (this.revolverRGSData.variant) {
            return this.revolverRGSData.variant;
        }

        return DeviceInfo.isDesktop ? "desktop" : "mobile";
    }

    public getForceStrings() {
        return this.revolverRGSData.forceStrings;
    }

    public getOperatorId() {
        return this.revolverRGSData.operatorId;
    }

    public getGameId() {
        return this.revolverRGSData.gameId;
    }

    public getDemoCurrency() {
        return this.revolverRGSData.currency || null;
    }

    public getLoader() {
        return this.revolverRGSData.loader;
    }

    public convertPositionsToGridPositions(positions: number[]): Point[] {
        const toReturn = [];

        let positionIndex = 0;
        for (let x = 0; x < SlotDefinition.matrixGrid.length; x++) {
            const col = SlotDefinition.matrixGrid[x];
            for (let y = 0; y < col; y++) {
                positionIndex++;
                for (const position of positions) {
                    if (positionIndex === position) {
                        toReturn.push(new Point(x, y));
                    }
                }
            }
        }

        return toReturn;
    }

    public isSpin(tested: string): boolean {
        if (tested) {
            for (const name of this.spinIdentifiers) {
                if (tested.indexOf(name) > -1) {
                    return true;
                }
            }
        }
        return false;
    }

    public isFreespin(tested: string): boolean {
        if (tested) {
            for (const name of this.freespinIdentifiers) {
                if (tested.indexOf(name) > -1) {
                    return true;
                }
            }
        }
        return false;
    }
}

export default new RevolverModel();



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/integration/revolver/model/revolver-model.ts